import { Component, ElementRef } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { GoogleMapsService } from "../providers/google-maps";
import { Subscription } from "rxjs/Subscription";

@Component({
    selector: '[google-map]',
    template: '',
})
export class GoogleMap {

    private isReady: boolean = false;
    private readyCallbacks: Function[] = [];

    private map: google.maps.Map;
    private markers: google.maps.Marker[] = [];

    public boundsChanged = new Subject<google.maps.LatLngBounds>();

    constructor(
        private elementRef: ElementRef,
        private googleMaps: GoogleMapsService,
    ) {

    }

    public ngAfterViewInit() {
        this.googleMaps.ready(() => {
            this.map = this.createMap();

            for (let marker of this.markers) {
                marker.setMap(this.map);
            }

            this.isReady = true;

            for (let callback of this.readyCallbacks) {
                callback();
            }
        });
    }

    public addMarker(options: google.maps.MarkerOptions): google.maps.Marker;
    public addMarker(marker: google.maps.Marker): google.maps.Marker;
    public addMarker(input): google.maps.Marker {
        let marker: google.maps.Marker;

        if (input instanceof google.maps.Marker) {
            marker = input;
        } else {
            let options: google.maps.MarkerOptions = input;
            marker = this.createMarker(options)
        }

        this.markers.push(marker);

        if (this.map) marker.setMap(this.map);

        return marker;
    }

    public clearMarker(marker: google.maps.Marker) {
        let index = this.markers.indexOf(marker);
        this.markers.splice(index, 1);
        marker.unbindAll();
        marker.setMap(null);
        marker = null;
    }

    public clearMarkers() {
        for (let marker of this.markers) {
            this.clearMarker(marker);
        }
        this.markers = [];
    }

    public createMap(): google.maps.Map {
        let map = new google.maps.Map(this.elementRef.nativeElement, {
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            zoom: 10,
        });

        map.addListener('bounds_changed', () => this.boundsChanged.next(this.getBounds()));

        return map;
    }

    public createMarker(options: google.maps.MarkerOptions): google.maps.Marker {
        return new google.maps.Marker(options);
    }

    public getBounds(): google.maps.LatLngBounds {
        return this.map.getBounds();
    }

    public ready(): Promise<void> {
        if (this.isReady) return Promise.resolve();

        return new Promise<void>(resolve => {
            this.readyCallbacks.push(resolve);
        });
    }

    public setCenter(center: google.maps.LatLng | google.maps.LatLngLiteral) {
        this.map.setCenter(center);
    }

    public setZoom(zoom: number) {
        this.map.setZoom(zoom);
    }

}



// WEBPACK FOOTER //
// ./src/components/google-map.ts